export async function updateTrackingNumber(prescriptionId, payload) {
  const res = await window.axios({
    method: 'POST',
    baseURL: process.env.VUE_APP_EPRES_ENDPOINT,
    url: `pharmacist/${prescriptionId}/trackingNumber`,
    data: payload,
  });

  return res;
}
